module.exports = __webpack_public_path__ + "img/sjbjk.341985c1.png";